// Grip: a pistol grip raked back by `deg`, with hatching and a trigger guard loop.
import { detailStroke, type Part, part } from '../../passes.ts';
import { box, line, roundPoly } from '../../shapes.ts';
import type { GunKit } from './types.ts';

export function grip(g: GunKit): Part {
  const { x, w, len, deg } = g.r.grip;
  const y0 = g.r.receiver.y + g.r.receiver.h - 3;
  const dx = Math.tan((deg * Math.PI) / 180) * len;
  const pts: [number, number][] = [
    [x, y0],
    [x + w, y0],
    [x + w - dx, y0 + len],
    [x - dx - 1, y0 + len],
  ];
  const sw = g.pal.sw(g.r.gripTok);
  return part(roundPoly(pts, 4), sw, box(x - dx - 1, y0, w + dx + 1, len), {
    detail: (c) => {
      for (let i = 1; i <= 3; i++) {
        const t = 0.25 + i * 0.16;
        detailStroke(
          c,
          line([
            [x + 3 - dx * t, y0 + len * t],
            [x + w - 3 - dx * t, y0 + len * t],
          ]),
          sw.shade,
          g.ow * 0.55,
        );
      }
      // trigger guard in front of the grip
      const gx = x + w + 1;
      detailStroke(
        c,
        (cc) => {
          cc.moveTo(gx, y0);
          cc.quadraticCurveTo(gx, y0 + 10, gx + 7, y0 + 9);
          cc.quadraticCurveTo(gx + 12, y0 + 8, gx + 11, y0);
        },
        sw.outline,
        g.ow * 0.9,
      );
    },
  });
}
